/** Formats an ISO timestamp into separate date and time strings, e.g. "Sep 9, 2026" / "2:04 PM". */
export function formatRequestedAt(isoString?: string | null): { date: string; time: string } | null {
  if (!isoString) return null;
  const parsed = new Date(isoString);
  if (Number.isNaN(parsed.getTime())) return null;
  return {
    date: parsed.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }),
    time: parsed.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }),
  };
}
